import React, { useState } from "react";

const TrimmedTextUI = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  const words = text.trim().split(/\s+/); // Split on spaces
  const shouldTrim = words.length > 15;
  const shortText = words.slice(0, 15).join(" ");

  const toggleExpanded = () => setExpanded(prev => !prev);

  return (
    <>
      
        {expanded || !shouldTrim ? text : `${shortText}...`}
      
      {shouldTrim && (
        <button onClick={toggleExpanded} style={{ color: "black", cursor: "pointer", background: "none", border: "none" }}>
          {expanded ? "See less" : "See more"}
        </button>
      )}
    </>
  );
};

export default TrimmedTextUI;